import React, {Component} from 'react';
import {Factory as LineupPlayersFactory} from './lineup-players/factory';
import {Factory as LineupDetailsFactory} from 'components/organisms/lineup/components/desktop/lineup-details/factory';
import {connect} from 'react-redux';

class Lineup extends Component {
    render() {
        const {sportConfig, lineup, lineupPlayers} = this.props;

        if (!lineup) {
            return null;
        }

        const LineupDetails = LineupDetailsFactory.getComponent(sportConfig);
        const LineupPlayers = LineupPlayersFactory.getComponent(sportConfig);

        return (
            <div className="lineup-box">
                <div className="lineup-header">
                    <LineupDetails lineup={lineup} />
                </div>
                <LineupPlayers lineupPlayers={lineupPlayers} />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, lineupsData} = state;

    return {
        sportConfig,
        lineupsData,
    };
}

export default connect(mapStatesToProps)(Lineup);
